import { AbstractControl } from "@angular/forms";

export function passwordValidator(control : AbstractControl): {[key : string ] : boolean} | null {
    const newPassword = control.get('newPassword');
    const confirmPassword = control.get('confirmPassword');
    if(newPassword.pristine || confirmPassword.pristine || confirmPassword.value==='' ){
      return null;
    }
    return newPassword && confirmPassword && newPassword.value !==confirmPassword.value ? 
    {'passowrdMismatch' : true} : null;
}